/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { z } from 'zod'

export class LoginErrorUnmatchedState extends Error {}
export class LoginErrorExpired extends Error {}
export class LoginErrorUnknown extends Error {}

export const LoginErrorParam = z.enum(['login_session_expired'])

export class ErrorHelpers {
  static deduceLoginError = (error: string) => {
    switch (error) {
      case LoginErrorParam.Enum.login_session_expired:
        return new LoginErrorExpired()
      default:
        return new LoginErrorUnknown()
    }
  }
}
